export default class ListFilter {
    constructor($element) {
        this.$element = $element;
        this.$options = this.$element.querySelectorAll('[data-list-filter-option]');

        this.changeView = this.changeView.bind(this);

        this.$options.forEach($trigger => $trigger.addEventListener('change', this.changeView));
    }

    changeView(e) {
        var list = document.querySelectorAll('[data-list-item-type="'+e.target.value+'"]:not(.hidden)');

        list.forEach($item => {
            $item.style.display = e.target.checked ? 'block' : 'none';
        });
    }
}